import { importExportValues } from '../../../../constants';

export const columnIndexKeyMap: Record<string, number> = {
  containerNumber: 0,
  billingAccount: 1,
  urgency: 2,
  bookingBLNumber: 3,
  customerTO: 4,
  customerPO: 5,
  ediShipmentId: 6,
  legType: 7,
  shippingLine: 8,
  terminal: 9,
  consigneeId: 10,
  ingateDropoffAccount: 11,
  vessel: 12,
  vesselEta: 13,
  lfd: 14,
  netWeight: 15,
  containerSize: 16,
  dropOrLive: 17,
  deliveryMethod: 18,
  zendeskTicketId: 19,
  invoiceDrayAndFSCTo: 20
} as const;

export const importExportValuesMap: Record<string, string> = {
  Import: importExportValues.import,
  Export: importExportValues.export,
  'Gray Pool Import': importExportValues.grayPoolImport
} as const;

export const dropPickColValuesMap: Record<string, string> = {
  Live: 'live',
  'Drop w/o Backhaul': 'drop_only',
  'Drop & Pick': 'droppick'
} as const;

export const deliveryMethodColValuesMap: Record<string, string> = {
  'Pierpass paid by customer': 'bycustomer',
  'Pierpass paid by DA': 'byda',
  'N/A': 'na'
} as const;
